export default {
  docTitle: "Authing developer",
  banner: {
    title: "Developer",
    subtitle: "Using Authing for five minutes to realize single sign-on and complete authentication and authorization",
  },
  nav: {
    sso: "Single sign on",
    use: "Using Authing",
    sdk: "SDK Access",
    authorize: "Authorization",
    security: "Security",
    thirdLogin: "Third Login",
    formLogin: "Form Login ",
    scanLogin: "Scan Login",
    integrated: "Integrated",
    practice: "Practice",
    other: "Other",
  },
  status: {
    currentStatus: "Current state",
    unLogin: "Not logged in",
    login: " Hello, you are already logged in",
    web: "Web login",
    app: "Wechat mobile website login",
    session: "Here is your conversation information",
    sessionTitle: "User information",
  },
  use: {
    title: "Using Authing",
    "item-one": {
      title: "Register Authing",
      subtitle:
        "Explore how to create an Authing developer account, and get familiar with the overall operation mode of the Authing system.",
      "list-one": "· Authing userpool",
      "list-two": "· Authing console",
      "list-three": "· User pool information",
    },
    "item-two": {
      title: "Quick start",
      subtitle: "An example of SSO using Authing and guard.",
      "list-one": "· Go to the SDK repository",
    },
    "item-three": {
      title: "Development documents",
      subtitle:
        "Learn how to use Authing for development and understand the professional knowledge of identity authentication.",
      "list-one": "· What does Authing do?",
      "list-two": "· What can we do for you?",
      "list-three": "· The technical terms we use",
    },
  },
  sdk: {
    title: "SDK Access",
    subtitle:
      "Multi-language SDK is provided to encapsulate API signature calculation for users, organize request structure, build connection pool, improve request efficiency and performance, parse returned results, etc.",
    item0: {
      title: "Minprogram SDK",
    },
  },
  authorize: {
    title: "Authorization",
    "item-one": {
      title: "Configure user permissions",
      subtitle: "In the Authing console, users' rights and operation flow can be quickly configured.",
    },
    "item-two": {
      title: "Read/modify user permissions in code",
      subtitle: "Authing Access control.",
    },
  },
  security: {
    title: "Security",
    "item-one": {
      title: "Configure MFA security password",
      subtitle: "Multi-factor authentication (MFA) is a security system",
    },
    "item-two": {
      title: "Configure web security domain",
      subtitle: "How to configure web security domain.",
    },
    "item-three": {
      title: "Configure password strength",
      subtitle: "Configure the password strength in the Security > user password and data encryption page.",
    },
    "item-four": {
      title: "Configure password encryption function",
      subtitle: "Customize the encryption method of user password in user pool.",
    },
  },
  thirdLogin: {
    title: "Third-party login",
    item0: {
      title: "Access to social login",
      subtitle: "Authing Social login supports two modes: hosting mode and manual mode.",
    },
    item1: {
      title: "Access to wechat mobile page and log in with authorization",
      subtitle: "Wechat mobile page authorized login.",
    },
    item2: {
      title: "Using OIDC",
      subtitle: "OIDC is an extension of OAuth 2.0, which mainly adds semantic user information fields.",
    },
    item3: {
      title: "Using OAuth 2.0",
      subtitle: "Use OAuth 2.0 to use the Authing user pool as an identity service provider.",
    },
    item4: {
      title: "Use SAML",
      subtitle: "SAML 2.0 can realize single sign-on (SSO) based on network cross-domain.",
    },
    item5: {
      title: "Configure a third-party LDAP service",
      subtitle: "LDAP is a tree-type database used to store user and organization information.",
    },
    item6: {
      title: "Use Authing's LDAP user directory",
      subtitle: "Authing supports the use of LDAP protocol to view, modify, add and delete user information.",
    },
  },
  formLogin: {
    title: "Form Login",
    "item-one": {
      title: "Guard Login Form",
      subtitle: "Guard is a login form, users can easily authenticate using the selected connection.",
    },
    "item-two": {
      title: "Guard VS Custom UI",
      subtitle: "When connecting Authing to your application, the best solution is to use Authing...",
    },
  },
  scanLogin: {
    title: "Scan QR Code Login",
    "item-one": {
      title: "Access Mini Program Scan Code Login",
      subtitle:
        'Scan the QR code of the applet and use the applet "Small Login" for authentication. Using the "Small Login" will increase the registration conversion rate by 80% and save 100% of the SMS cost. ',
    },
    "item-two": {
      title: "Access to the privatized applet",
      subtitle: 'If you are a user of private deployment "small login", please check this chapter for access. ',
    },
  },
  integrated: {
    title: "System Integration",
    "item-one": {
      title: "Confluence Access Authing OIDC Guide",
      subtitle: "Introduce in detail how Confluence accesses Authing OIDC.",
    },
    "item-two": {
      title: "Spring Security 5 Integrated Authing OIDC Single Sign-On Guide",
      subtitle: "Introduce in detail how Spring Security 5 accesses Authing OIDC.",
    },
  },
  practice: {
    title: "Best Practice",
    "item-one": {
      title: "Express Integrated OIDC Single Sign-On Guide",
      subtitle: "Details how Express integrates Authing OIDC single sign-on.",
    },
  },
  other: {
    title: "Other",
    "item-one": {
      title: "Code example for opening the login page in a single window",
      subtitle: "You can view the code example.",
    },
    "item-two": {
      title: "Error Code",
      subtitle: "Error code message format.",
    },
    "item-three": {
      title: "Learn about the free emails and text messages that come with Authing",
      subtitle: 'E-mail is an e-mail sending service provided by Authing for users registered with "Mailbox". ',
    },
  },
  button: {
    doc: "SSO Document",
    experience: "Click to experience",
    logout: "Logout",
    quickLogin: "Quick Login",
    "learn-more": "View Details",
  },
  wxLogin: "WeChat mobile web login",
};
